import { FormGroup, FormLabel, Stack } from '@mui/material';
import ActionButton from 'common/components/ActionButton';
import PhoneInput from 'common/components/PhoneInput';
import RenderFormFields from 'common/features/renderForms/RenderFormFields';
import useFlexBoxStyles from 'common/flexBox';
import { findCountryCodeByCountryName } from 'common/utils/countryList';
import { useFormFields } from 'libs/hooksLib';
import { useSnackbar } from 'notistack';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { useDispatch, useSelector } from 'react-redux';
import { closeCustomDialogAction } from 'redux/slices/customDialogSlice';
import { getNestedDialogStateData } from 'redux/slices/nestedDialogSlice';
import { getOrganization } from 'redux/slices/organizationSlice';

import { getServicesSavePending } from 'redux/slices/iCalendarV4';
import CustomTextValidator from '../../../../common/components/CustomTextValidators';
import { getDynamicFields } from '../../../../common/features/renderForms/utils';
import { withFormConfig } from '../../../contacts/withFormConfig';

const AppointmentFormActorForm = withFormConfig(
    {
        type: 'appointment_guest_extra_fields',
    },
    ({ formConfig, actor, onSubmit, onCancel }) => {
        const { classes: flexBox, cx } = useFlexBoxStyles();
        const { t } = useTranslation();
        const { enqueueSnackbar } = useSnackbar();
        const dispatch = useDispatch();
        const savePending = useSelector(getServicesSavePending);
        const nestedDialogStateData = useSelector(getNestedDialogStateData);
        const organization = useSelector(getOrganization);
        // const confirmTitle = t('common.cancelConfirm');
        // const confirmMessage = t('appointment.actorForm.cancelMessage');

        const initialForm = useMemo(() => {
            const initial = {
                firstName: actor?.firstName || '',
                lastName: actor?.lastName || '',
                email: actor?.email || '',
                phone: actor?.phone || '',
            };
            const dynamic = getDynamicFields(formConfig, actor?.extraFields);
            return { ...initial, ...dynamic };
        }, [actor, formConfig]);

        const [fields, handleFieldChange, resetForm] = useFormFields(nestedDialogStateData || initialForm);

        // const actorDidChange = useCallback(() => {
        //     const { ...original } = initialForm;
        //     const { ...current } = fields;
        //     return !isEqual(original, current);
        // }, [fields, initialForm]);

        const restart = useCallback(() => {
            resetForm(initialForm);
        }, [initialForm, resetForm]);

        const finalCancel = useCallback(() => {
            restart();
            onCancel?.();
        }, [restart, onCancel]);

        // const manageCancel = useCallback(() => {
        //     if (!actorDidChange()) {
        //         finalCancel();
        //     }
        // }, [finalCancel, actorDidChange]);

        const cancel = (event) => {
            event.preventDefault();
            finalCancel();
            //manageCancel();
        };

        const submitActor = (data) => {
            onSubmit({
                data,
                onSuccess: () => {
                    resetForm(initialForm);
                    dispatch(closeCustomDialogAction());
                },
                onFailure: (error) => {
                    enqueueSnackbar(t('app.common.error'), { variant: 'error' });
                },
            });
        };

        const handleSubmit = (e) => {
            e.preventDefault();
            // submitActor({
            //     firstName: fields.firstName?.trim(),
            //     lastName: fields.lastName?.trim(),
            //     email: fields.email?.trim(),
            //     phone: fields.phone?.trim(),
            //     extraFields: getNestedData(formConfig, fields, { excludeLabels: true }),
            // });
            submitActor(fields);
        };

        const isValidForm = () => {
            return fields.email;
        };

        const handleError = (error) => {
            console.error('🚀 ~ handleError ~ error:', error);
        };

        const defaultFields = useMemo(() => {
            return [
                {
                    name: 'firstName',
                    component: (
                        <FormGroup>
                            <FormLabel>{t('user.form.firstName')}</FormLabel>
                            <CustomTextValidator
                                name="firstName"
                                fullWidth={true}
                                variant="outlined"
                                size="small"
                                value={fields.firstName}
                                onChange={handleFieldChange}
                                validators={[]}
                                errorMessages={[]}
                            />
                        </FormGroup>
                    ),
                },
                {
                    name: 'lastName',
                    component: (
                        <FormGroup>
                            <FormLabel>{t('user.form.lastName')}</FormLabel>
                            <CustomTextValidator
                                name="lastName"
                                fullWidth={true}
                                variant="outlined"
                                size="small"
                                value={fields.lastName}
                                onChange={handleFieldChange}
                                validators={[]}
                                errorMessages={[]}
                            />
                        </FormGroup>
                    ),
                },
                {
                    name: 'email',
                    component: (
                        <FormGroup key="email">
                            <FormLabel>{t('contact.email')}</FormLabel>
                            <CustomTextValidator
                                name="email"
                                fullWidth={true}
                                variant="outlined"
                                size="small"
                                value={fields.email}
                                onChange={handleFieldChange}
                                validators={['isEmail']}
                                errorMessages={[t('user.userInviteForm.emailInvalid')]}
                            />
                        </FormGroup>
                    ),
                },
                {
                    name: 'phone',
                    component: (
                        <PhoneInput
                            key="phone"
                            value={fields.phone}
                            name="phone"
                            label={t('contact.phone')}
                            onChange={handleFieldChange}
                            defaultCountryCode={findCountryCodeByCountryName(organization?.country)}
                            countryCodeSeparator=""
                            hideCountryCode={false}
                            validators={[`matchRegexp:\\d*`]}
                            errorMessages={[t('app.common.invalidInput.error')]}
                        />
                    ),
                },
            ];
        }, [
            t,
            fields.firstName,
            fields.lastName,
            fields.email,
            fields.phone,
            handleFieldChange,
            organization?.country,
        ]);

        return (
            // <LayoutForm
            //     title={action}
            //     size={'medium'}
            //     confirmDlg={{
            //         open: openCancelDlg,
            //         accept: finalCancel,
            //         cancel: cancelDlg,
            //         titleDlg: confirmTitle,
            //         messageDlg: confirmMessage,
            //     }}
            // >
            <Stack direction="column" spacing={2} className={cx(flexBox.overflowHidden, flexBox.h100)}>
                <Stack direction="column" spacing={3} className={cx(flexBox.overflowHidden, flexBox.h100)}>
                    <ValidatorForm
                        onSubmit={() => {}}
                        onError={handleError}
                        className={cx(flexBox.flex, flexBox.gap2, flexBox.column, flexBox.overflowHidden, flexBox.h100)}
                    >
                        <Stack
                            spacing={2}
                            direction="column"
                            className={cx(flexBox.overflowXHidden, flexBox.scrollbarNone, flexBox.h100)}
                        >
                            <RenderFormFields
                                defaultFields={defaultFields}
                                formConfig={formConfig}
                                fields={fields}
                                handleFieldChange={handleFieldChange}
                            />
                        </Stack>
                    </ValidatorForm>

                    <Stack
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                        spacing={1}
                        className={flexBox.paddingTop2}
                    >
                        <ActionButton onClick={cancel} color="default" fitWidth>
                            {t('app.common.cancel')}
                        </ActionButton>

                        <ActionButton
                            color="primary"
                            autoFocus
                            fitWidth
                            disabled={savePending || !isValidForm()}
                            onClick={handleSubmit}
                        >
                            {t('app.common.save')}
                        </ActionButton>
                    </Stack>
                </Stack>
            </Stack>
            // </LayoutForm>
        );
    },
);

export default AppointmentFormActorForm;
